module.exports = __webpack_public_path__ + "static/media/recepcion.28b2c11b.jpg";